// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1014":"1c7d44f3","3363":"a4de55bd"}[chunkId] + ".chunk.css";
};